import React, { useEffect } from 'react';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import './TermsConditions.css';
import Topbar from './Topbar';
export default function TermsConditions() {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  return (
    <>
    <div><Topbar/></div>
      <Navbar />
      <section className="TermsConditions">
        <h1>Terms and Conditions</h1>
        <p>Welcome to Apollo Agency! By using our services, you agree to the following terms and conditions.</p>

        <h2>1. Introduction</h2>
        <p>These Terms and Conditions govern the use of our services provided by Apollo Agency. By accessing our services, you accept these terms in full.</p>

        <h2>2. Services Offered</h2>
        <p>We offer property services including buying, selling, renting, and leasing of residential and commercial properties. Our team is dedicated to ensuring the best service and customer satisfaction.</p>

        <h2>3. User Responsibilities</h2>
        <p>Users are responsible for providing accurate information regarding their property requirements, including budget and location preferences, and ensuring access to properties during viewings.</p>

        <h2>4. Service Availability</h2>
        <p>Our services are available Monday to Saturday, from 9 AM to 6 PM. Service availability may vary based on location and scheduling.</p>

        <h2>5. Pricing</h2>
        <p>All service charges will be communicated upfront before any property transactions, including fees for property purchases, sales, rentals, and leases. Additional costs may apply for additional services.</p>

        <h2>6. Payments</h2>
        <p>Payments for property transactions must be made as agreed upon in the contract. We accept various payment methods for convenience.</p>

        <h2>7. Cancellations</h2>
        <p>If you need to cancel or reschedule any property-related service, please notify us at least 24 hours in advance to avoid cancellation fees.</p>

        <h2>8. Warranty</h2>
        <p>We provide a warranty on services related to property transactions. Specific warranty details will be discussed before any transactions are finalized.</p>

        <h2>9. Limitation of Liability</h2>
        <p>We strive to provide excellent service; however, we cannot be held liable for any issues resulting from actions or conditions outside of our control, including disputes with third-party entities involved in property transactions.</p>

        <h2>10. Customer Support</h2>
        <p>If you have any questions or concerns regarding our services, please contact our customer support team. We are here to assist you with any property-related inquiries.</p>

        <h2>11. Modifications</h2>
        <p>Apollo Agency reserves the right to modify these terms at any time. Any changes will be communicated to users through our website or via email.</p>

        <h2>12. Governing Law</h2>
        <p>These terms shall be governed by and construed in accordance with the laws of the applicable jurisdiction in which Apollo Agency operates.</p>

        <h2>13. Privacy Policy</h2>
        <p>Your privacy is important to us. Please refer to our Privacy Policy for details on how we collect, use, and protect your information.</p>

        <h2>14. Termination</h2>
        <p>Apollo Agency reserves the right to suspend or terminate services for any user who violates these terms or engages in unlawful behavior.</p>

        <h2>15. Contact Us</h2>
        <p>If you have any questions about these Terms and Conditions, please contact us at <a href="mailto:info.appolloagency@gmail.com.com">info.appolloagency@gmail.com</a>.</p>
      </section>
      <Footer />
    </>
  );
}
